import { useEffect, useState } from 'react';
import './style.scss';
import {
  IProjectDocInfo,
  IContentNav,
} from '../../../model/api-modules/document';
import menuDown from '../../../assets/images/menu-down.png';
import { LanguageType } from '../../../model';
import { RightCatalogueItem } from './right-catalogue-item';

interface IProps {
  readonly projectDocInfo: IProjectDocInfo | undefined;
  readonly contentNav: ReadonlyArray<IContentNav> | undefined;
  readonly activeId: string;
  readonly setActiveId: (value: string) => void;
  readonly isRight?: boolean;
  readonly lang: LanguageType | null;
}

export const RightCatalogue = (props: IProps) => {
  const [isExpand, setIsExpand] = useState<boolean>(false);
  const [isOpenList, setIsOpenList] = useState<number[]>([]);

  const handleScroll = () => {
    const el = document.querySelector('.right-anchor') as HTMLElement;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (el) {
      if (scrollTop > 60) {
        el.style.top = '40px';
      } else {
        el.style.top = `${100 - scrollTop}px`;
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
  }, []);

  const onSelectMenu = (itemId: number) => {
    const newOpenList = JSON.parse(JSON.stringify(isOpenList));
    if (newOpenList.indexOf(itemId) === -1) {
      newOpenList.push(itemId);
    } else {
      newOpenList.splice(newOpenList.indexOf(itemId), 1);
    }
    setIsOpenList(newOpenList);
  };

  return (
    <div className={props.isRight ? 'isRight anchor' : 'notRight anchor'}>
      {/* <div className="m-anchor-btn-box">
            </div> */}
      <div className={props.isRight ? 'a-box right-anchor' : 'a-box'}>
        {props.contentNav && props.contentNav.length > 0 && (
          <p className="a-box-title" onClick={() => setIsExpand(!isExpand)}>
            {props.lang === LanguageType.ZH ? '本页目录:' : 'On this page'}
            {!props.isRight && (
              <img
                src={menuDown}
                className={
                  isExpand ? 'expand-img' : 'expand-img expand-img-hidden'
                }
              />
            )}
          </p>
        )}
        {(isExpand || props.isRight) && (
          <div className="a-menu">
            <ul className="a-list">
              {props.contentNav &&
                props.contentNav.length > 0 &&
                props.contentNav.map((item: IContentNav, index: number) => {
                  return (
                    <RightCatalogueItem
                      itemData={item}
                      itemKey={`${index}`}
                      setActiveId={props.setActiveId}
                      activeId={props.activeId}
                      onSelectMenu={onSelectMenu}
                      isOpenList={isOpenList}
                    />
                  );
                })}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};
